import { useQuery } from '@tanstack/react-query';

import { stripeAccountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const shouldFetchStripeCustomer = ({
  isStripeBilling,
  isStripePayments,
  isCustomer,
}: {
  isStripeBilling: boolean;
  isStripePayments: boolean;
  isCustomer: boolean;
}) => isCustomer && (isStripeBilling || isStripePayments);

export const useStripeCustomer = (isStripeTurnedOn: boolean) => {
  const query = useQuery({
    queryKey: [QueryKeys.STRIPE_CUSTOMER],
    queryFn: stripeAccountRepo.getStripeCustomer,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: isStripeTurnedOn,
  });

  return useQueryMemoized(query);
};

export type UseStripeCustomer = ReturnType<typeof useStripeCustomer>;
